import React, { useState, useEffect } from 'react';
import Layout from '../core/Layout';
import Card from '../core/Card';
import { getMyListedItems } from './apiUser';
import { isAuthenticated } from '../auth';
import { Link } from 'react-router-dom';

const MyItems = () => {
    const {user: {_id}, token} = isAuthenticated();
    
    const [userListedItems, setUserListedItems] = useState({
        listedItems: [],
        error: ''
    });
    
    const { listedItems } = userListedItems;
    
    const init = () => {
        getMyListedItems(_id, token).then(data => {
            if (data.error) {
                setUserListedItems({...userListedItems, error: data.error});
            }
            else {
                console.log(data);
                setUserListedItems({...userListedItems, listedItems: data});
            }
        });

    };
    

    useEffect(() => {
        init();
    },[]);

    const addItem = () => (
        <Link to='/user/create-listing'>
            <button className='btn btn-outline-primary mt-2 mb-2 mr-2'>
                Add New Item
            </button>
        </Link>
   );

    const listMyListedItems = () => {
        return (
            <div className='row'>
                <h3> Items on Market</h3>
                {listedItems&& listedItems.map((item, i) => (<Card key={i} listing={item} />))}
            </div>
        );
    }

    return (
        <Layout title='Your Items' description='Select one of your items to be listed to trade'>
            {addItem()} 
            <br/>
            <hr/>
            {listMyListedItems()}

        </Layout>
    );
    
};

export default MyItems;
